import React from "react";

const Accordion = ({ id, children, flush = true }) => (
	<div className={`accordion ${flush && "accordion-flush"}`} id={id}>
		{children}
	</div>
);

export default Accordion;
